module.exports = __webpack_public_path__ + "img/clock (1).88340428.svg";